import axios from "../../axios";

const approve = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.post('admin/pay-out/approve', {}, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default approve;
